<template>
    <div class="mb-2">
        <!-- Global card layout -->
        <div class="mx-w-sm border border border-gray-200 rounded-b-md shadow shadow-all duration-500 overflow-hidden rounded-t-lg">
            <div class="rounded-t-lg overflow-hidden">
                <div class="relative image-height" v-bind:style="{ backgroundImage: 'url(' + baseUrlSrc(data && data.thumbnail_url) + ')' }">
                    <!-- <img class="card-image" :src="baseUrlSrc(data && data.thumbnail_url)" alt="" @error="defaultImage"/> -->
                    <div class="absolute top-2 rounded-md right-2" v-if="isFavourite && getToken()">
                        <div class="flex items-center justify-center h-full">
                            <button
                                @click.prevent="favouriteHandler('no')"
                                class="text-xs text-gray-dark focus:outline-none"
                                v-if="data.is_favourite === 'yes'"
                            >
                                <HeartFill />
                            </button>
                            <button
                                @click.prevent="favouriteHandler('yes')"
                                class="text-xs text-gray-dark focus:outline-none"
                                v-else
                            >
                                <Heart fillStr="#fff"/>
                            </button>
                        </div>
                    </div>
                    <div class="absolute bottom-2 right-2 bg-white bg-opacity-10 rounded-md px-2 py-1 text-sm text-blackgreylight" v-if="data.entity_type == 2">
                        <div class="course-session">
                            <div class="flex">
                                <div class="icon">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-5 w-5"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                                        />
                                    </svg>
                                </div>
                                <div class="">
                                    {{ data.no_of_sessions }}
                                    {{ data.no_of_sessions > 1 ? "Sessions" : "Session" }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-4">
                <!-- <pre>{{ data }}</pre> -->
                <h5 class="capitalize text-xl font-bold tracking-tight text-gray-900 dark:text-white truncate">
                    {{data && data.title}}
                </h5>
                <p class="text-gray-700 text-base mb-2">
                    {{ isTrainerName ? (data.trainer_name) || 'Trainer Name' : data.difficulty_name}}
                </p>
                <div class="rating mt-3" v-if="isRating">
                    <div class="flex items-center">
                        <div class="flex space-x-2">
                            <Rating :data="data.avg_rating"/>
                        </div>
                        <div>
                            <span class="bg-blue-100 text-blue-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800 ml-3">
                                {{data && data.avg_rating==null ? "0" : data && data.avg_rating  }}
                            </span>
                        </div>
                    </div>
                </div>
                
                <div class="tags mt-3" v-if="isCategory">
                    <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
                        {{ data && data.category }}
                        {{ data && data.category_name }}
                    </span>
                    <span v-if="isLanguage" class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
                        {{ (data && data.language_name) || "-" }}
                    </span>
                </div>

                <div class="price booking mt-4">
                    <div class="flex items-center justify-between">
                        <span class="text-xl font-bold text-gray-900 dark:text-white">
                            {{ data.cost == 0 ? 'Free' : `$ ${intToFloat(data && data.cost, 2)}` }}
                        </span>
                        <button
                          @click="redirectionHandler"
                          class="inline-flex items-center h-8 px-2 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
                        >
                          {{data && data.entity_type && data.entity_type == 2 ? 'Class Pack Detail' : 'Class Detail'}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Heart,HeartFill,Star } from "@/components/icons";
import { Rating } from "@/components/t-components";
import { mapActions, mapGetters } from 'vuex';
export default {
    components: {
    Heart,
    Star,
    HeartFill,
    Rating,
  },
  props: {
    data: {
      type: Object,
    },
    isTrainerName: {
      type: Boolean,
      default: true,
    },
    isCategory:{
        type: Boolean,
        default:true,
    },
    isFavourite:{
        type:Boolean,
        default: false,
    },
    isRating:{
        type:Boolean,
        default:true,
    },
    isLanguage:{
        type:Boolean,
        default:true,
    },
    redirectpath:{
        type: Object,
    }
  },
  methods: {
    ...mapActions([
      "postUserSessionAddRemoveFavourite",
      "getUserSessionDetail",
      "getUserTrendingSessions"
    ]),
    async favouriteHandler (favourite) {
      const data = {
        favourite: favourite,
        // entity_id: this.data.session_id || this.data.course_id,
        entity_id: this.data && (this.data.session_id || this.data.couse_id),
        entity_type: this.data && this.data.session_id && this.data.session_id > 0 ? 1 : 2
      }
      await this.postUserSessionAddRemoveFavourite(data).then(() => {
        this.data.is_favourite = data.favourite
      })
    },
    redirectionHandler(){
        this.$router.push(this.redirectpath);
    }
  },
}
</script>

<style scoped>
/* .image-area{
    min-height: 171px;
} */
.image-height{
    height: 170px;
    background-size: cover;
}
</style>